module.exports = __webpack_public_path__ + "img/q-and-a-white.bade5f1e.png";